import '../../App.css';
import LayerGroup from "ol/layer/Group";
import VectorLayer from "ol/layer/Vector";
import Source from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import Geometry from "ol/geom/Geometry";
import Feature from "ol/Feature";
import { getLayerName } from "../../TimeLine/MainTimeLineVisible";
import VectorSource from "ol/source/Vector";
import { map } from "../MainLayer";
import { Point } from 'ol/geom';


export default function AddRainfallLayer (
    receivedWeatherLayer: VectorLayer<VectorSource<Feature<Geometry>>>,
    isRemove: boolean,
    layerName: string
  ): void {
    if (!receivedWeatherLayer || !map) {
  //    console.error("Invalid layer or map reference.");
      return;
    }
  
    if (!layerName) {
   //   console.error("Layer name is required to add or remove layers.");
      return;
    }
  
    if (isRemove === false) {
      // Add the layer if it's not already present
        receivedWeatherLayer.set("name", layerName);
        map.addLayer(receivedWeatherLayer);
        getLayerName(layerName, true);
   
    } else {
      // Remove the layer if it exists
      const layersToRemove = map
        .getLayers()
        .getArray()
        .filter((layer) => layer.get("name") === layerName);
  
      layersToRemove.forEach((layer) => {
        map.removeLayer(layer);
     //   console.log(`Layer ${layerName} removed.`);
      });
  
      if (layersToRemove.length === 0) {
      //  console.log(`No layer found with the name ${layerName}.`);
      } else {
        getLayerName(layerName, false);
      }
    }
};

export function MarkerRainfallLayer (
  receivedWeatherLayer:VectorLayer<VectorSource<Feature<Point>>>,
  isRemove: boolean,
  layerName: string
): void {
  if (!receivedWeatherLayer || !map) {
    return;
  }

  if (!layerName) {
    return;
  }

  if (isRemove === true) {
      receivedWeatherLayer.set("name", layerName);
      map.addLayer(receivedWeatherLayer);
  } else {
    const removeOverlay = (key: string) => {
      const overlays = map.getOverlays().getArray();
      const overlaysToRemove = overlays.filter(
        (overlay) => overlay.getId() === key
      );
      overlaysToRemove.forEach((overlay) => {
        map.removeOverlay(overlay);
      });
    };
  }
};